import { render, staticRenderFns } from "./panel-left.vue?vue&type=template&id=6bef7fb0&scoped=true&"
import script from "./panel-left.vue?vue&type=script&lang=js&"
export * from "./panel-left.vue?vue&type=script&lang=js&"
import style0 from "./panel-left.vue?vue&type=style&index=0&id=6bef7fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef7fb0",
  null
  
)

export default component.exports